import { useState } from 'react';
import { useEmitter } from 'hooks/useEmitter';
import Structure from 'components/3catinfo/Structure';

const TabContent = (props) => {
    const { tabId, contentId } = props;
    const { onEmitter } = useEmitter();
    const [contentVisible, setContentVisible] = useState(false);

    onEmitter(tabId, (value) => {
        setContentVisible(value.id === contentId);
    });

    if (!contentVisible) return <></>;
    return (
        <div key={`tab-content-${contentId}`}>
            <Structure {...props} />
        </div>
    );
};

export default TabContent;
